<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background:#fbf7f7;padding-bottom:40px;"' class="" >
                <template #default>   <m-single-product-511 v-bind='{...{"productLink":"","product":"","useNativePrice":false,"showVariationProductImage":false,"variationProductComponent":"variation-product","showVariationTable":false,"showWallpaper":true,"wallpaper":null,"wallpaperOpacity":0.15,"background":null,"backgroundColor":"#fbf7f7","theme":"light","relatedProducts":true,"productCardName":"mProductCard525","productCardLink":true,"showKeywords":false,"offerStatus":true,"relatedSlideWidth":260,"trustItems":[{"title":"\u0636\u0645\u0627\u0646\u062a \u0627\u0635\u0627\u0644\u062a \u06a9\u0627\u0644\u0627","sub":"\u06a9\u06cc\u0641\u06cc\u062a \u062a\u0636\u0645\u06cc\u0646\u200c\u0634\u062f\u0647","icon":"bi bi-shield-check"},{"title":"\u0627\u0631\u0633\u0627\u0644 \u0633\u0631\u06cc\u0639 \u0648 \u0627\u06cc\u0645\u0646","sub":"\u0628\u0633\u062a\u0647\u200c\u0628\u0646\u062f\u06cc \u0634\u06cc\u06a9 \u0648 \u062a\u062d\u0648\u06cc\u0644 \u0633\u0631\u06cc\u0639","icon":"bi bi-truck"},{"title":"\u06f7 \u0631\u0648\u0632 \u0636\u0645\u0627\u0646\u062a \u0628\u0627\u0632\u06af\u0634\u062a","sub":"\u062e\u0631\u06cc\u062f \u0645\u0637\u0645\u0626\u0646 \u0628\u062f\u0648\u0646 \u0631\u06cc\u0633\u06a9","icon":"bi bi-arrow-counterclockwise"},{"title":"\u067e\u0634\u062a\u06cc\u0628\u0627\u0646\u06cc \u0648 \u0645\u0634\u0627\u0648\u0631\u0647","sub":"\u0647\u0645\u0631\u0627\u0647 \u0634\u0645\u0627 \u0642\u0628\u0644 \u0648 \u0628\u0639\u062f \u0627\u0632 \u062e\u0631\u06cc\u062f","icon":"bi bi-headset"}]},...{}}' :style='""' class="" ></m-single-product-511></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mSingleProduct511 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct511';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mSingleProduct511 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
